import React from 'react';
import { Navbar } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TopNavIcons from './TopNavIcons';
import transparentLogo from '../../assets/tendera_logo_transparent.png';

const pageTitles = {
    '/': 'navigation.home',
    '/search': 'navigation.search',
    '/my-profiles': 'navigation.myProfiles',
    '/mybids': 'navigation.myBids',
    '/decisions': 'navigation.decisions',
    '/decisions/chat': 'navigation.eye',
    '/settings': 'navigation.settings',
    '/help': 'navigation.help',
    '/ohjeet': 'navigation.help',
};

const TopNavbar = ({ onMenuOpen, isMobile }) => {
    const { t } = useTranslation();
    const location = useLocation();

    const getPageTitle = () => {
        const path = location.pathname;
        if (pageTitles[path]) return t(pageTitles[path]);
        for (const [key, value] of Object.entries(pageTitles)) {
            if (key !== '/' && path.startsWith(key + '/')) return t(value);
        }
        if (path.startsWith('/tender/')) return t('navigation.tenderView', 'Tender');
        return '';
    };

    if (isMobile) {
        return (
            <div style={{
                height: '56px',
                backgroundColor: '#27343A',
                display: 'flex',
                alignItems: 'center',
                paddingLeft: '1rem',
                paddingRight: '0.5rem',
                zIndex: 1000,
                flexShrink: 0,
            }}>
                <img
                    src={transparentLogo}
                    alt="Tendera"
                    style={{ height: '30px', objectFit: 'contain' }}
                />
                <span style={{
                    flex: 1,
                    textAlign: 'center',
                    color: '#FFFFFF',
                    fontWeight: 600,
                    fontSize: '1rem',
                }}>
                    {getPageTitle()}
                </span>
                <button
                    onClick={onMenuOpen}
                    aria-label="Open navigation menu"
                    style={{
                        border: 'none',
                        background: 'none',
                        cursor: 'pointer',
                        fontSize: '1.2rem',
                        color: '#FFFFFF',
                        padding: '4px 8px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <i className="fas fa-bars" />
                </button>
            </div>
        );
    }

    return (
        <Navbar
            style={{
                height: '56px',
                backgroundColor: '#FFFFFF',
                paddingLeft: '1rem',
                paddingRight: '1rem',
                // Below the sidebar (900): the bar spans the full width, so a higher
                // value paints over the sidebar's logo. Both stay under antd's
                // overlays (Drawer/Modal at 1000) so those still cover the chrome.
                zIndex: 880,
                borderBottom: '1px solid #dee2e6',
                display: 'flex',
                alignItems: 'center'
            }}
        >
            <TopNavIcons />
        </Navbar>
    );
};

export default TopNavbar;
